/**
 * @typedef {import('../../../api-v2/js-doc').V2AuditResponse} V2AuditResponse
 * @typedef {import('../../../api-v2/js-doc').V2User} V2User
 * @typedef {import('../../../api-v2/js-doc').V1Employee} V1Employee
 * @typedef {import('../../../api-v2/js-doc').V1UpdatedByUser} V1UpdatedByUser
 */

/**
 * @param {V2AuditResponse} v2Response - V2 response what contains createdAt and createdBy fields
 * @returns {V1UpdatedByUser}
 */
export const mapV2AuditResponseToV1 = (v2Response) => {
  return {
    changelog_notes: '',
    client: null,
    created_at: v2Response.createdAt,
    display_id: null,
    email: v2Response.createdBy.email,
    employee: mapV2UserToEmployee(v2Response.createdBy),
    firebase_key: '',
    id: v2Response.createdBy.id,
    last_login: new Date(),
    metadata: {},
    updated_at: v2Response.createdAt,
    updated_by: v2Response.createdBy.id,
    user_description: null,
  }
}


/**
 * @param {V2User} v2User - V2 user
 * @returns {V1Employee}
 */
const mapV2UserToEmployee = (v2User) => {
  return {
    changelog_notes: '',
    created_at: new Date(),
    extension: '',
    firebase_key: '',
    first_name: v2User.firstName || '',
    id: v2User.id,
    is_master: true,
    last_name: v2User.lastName || '',
    metadata: {},
    role: 'Master',
    status: 'active',
    updated_at: new Date(),
    updated_by:'', 
    user_id: v2User.id,
  }
}
